import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Row, Card, Space } from "@masterteam/mt-design-react";

import CircularProgress from "../../CircularProgress";
import DoubleCircularProgress from "../../DoubleCircularProgress";
import useIsAr from "../../../Hooks/useIsAr";

import styles from "./InitCard.module.scss";

const InitCard = ({ data }) => {
  const intl = useIntl();
  const [isAr] = useIsAr();

  return (
    <Card key={`initCard_${data.ID}`} className={styles.container}>
      <Space direction="vertical" gap={0}>
        <Row className={styles.header}>
          <div className="bold">
            {isAr ? data.ArabicName : data.EnglishName}
          </div>

          <div className={`bold ${styles.code}`}>
            {`${intl.formatMessage({
              id: "initiative.initiative-code",
            })}: `}
            <span>{data?.Code}</span>
          </div>
        </Row>

        <Row className={styles.content}>
          <Space direction="vertical">
            <FormattedMessage id="initiative.initiative-owner" />
            <div className={`bold ${styles.value}`}>
              {data.ManagerModel?.DisplayName}
            </div>
          </Space>

          <Space direction="vertical">
            <FormattedMessage id="initiative.initiative-status" />
            <div className={`bold ${styles.value}`}>
              <span
                className={styles.circle}
                style={{ backgroundColor: data?.ColorCode }}
              />
              {isAr ? data.ArabicStatus : data.EnglishStatus}
            </div>
          </Space>
        </Row>

        <Row
          direction="vertical"
          size="small"
          align="center"
          className={styles.progress}
        >
          <DoubleCircularProgress
            outerData={{
              value: data?.BaselineProgress,
              color: "var(--primary-color)",
              tipText: `${intl.formatMessage({
                id: "common.planned-progress",
              })}: ${data?.BaselineProgress}%`,
            }}
            innerData={{
              value: data?.Progress,
              color: "#00826C",
              displayText: true,
            }}
          />
        </Row>
      </Space>

      <Row size="small" align="center" className={styles.footer}>
        <Space>
          <Space direction="vertical" align="center">
            <p>{data?.ProgramsCount}</p>
            <FormattedMessage id="common.programs" />
          </Space>
        </Space>

        <Space>
          <Space direction="vertical" align="center">
            <p>{data?.RisksCount}</p>
            <FormattedMessage id="common.risks" />
          </Space>
        </Space>
      </Row>
    </Card>
  );
};

export default InitCard;
